<template>
  <div class="aibuy-explorer">
    <button class="aibuy-explorer__reload btn btn-sm btn-light" @click="reloadAlibuy">
      <i class="ri-refresh-line mr-1"></i>새로고침
    </button>
    <iframe
      ref="alibuyFrame"
      :src="alibuyUrl"
      class="aibuy-explorer__frame"
      allow="clipboard-write"
    />
  </div>
</template>

<script>
export default {
  name: 'AibuyExplorer',
  data() {
    return {
      alibuyKey: 0,
    };
  },
  computed: {
    alibuyUrl() {
      const base = 'https://aibuy.1688.com/landingpage/home/inventory/products.html';
      const params = new URLSearchParams({
        bizType: 'purchasingAgent',
        customerId: 'feiyun',
        lang: 'ko',
      });
      return `${base}?${params}`;
    },
  },
  methods: {
    reloadAlibuy() {
      this.alibuyKey++;
      this.$nextTick(() => {
        if (this.$refs.alibuyFrame) {
          this.$refs.alibuyFrame.src = this.alibuyUrl;
        }
      });
    },
  },
};
</script>

<style scoped>
.aibuy-explorer {
  position: relative;
  width: 100%;
  height: calc(100vh - 70px);
}
.aibuy-explorer__reload {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border: 1px solid #ddd;
  background: #fff;
  opacity: 0.9;
}
.aibuy-explorer__reload:hover {
  opacity: 1;
}
.aibuy-explorer__frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
